/* ============================================================
   PEAKBODY — THEME BEHAVIOUR (v2 "Peak")
   Cart runs on Shopify's AJAX API. Nothing is stored client-side;
   /cart.js is the single source of truth and every mutation re-reads it.
   ============================================================ */
(function () {
  "use strict";

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var PB = window.PB || {};
  var routes = PB.routes || {};
  var T = PB.strings || {};
  var moneyFormat = PB.moneyFormat || "${{amount}}";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
                     document.body.classList.contains("no-motion");

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- money ----------
     Mirrors Shopify's money filter for the values we render client-side. */
  function money(cents) {
    cents = Number(cents) || 0;
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var wholeDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, wholeDot)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, wholeDot + "," + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount\s*\}\}/, whole + "." + parts[1]);
  }
  function sizedImg(url, w) {
    if (!url) return "";
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }

  /* ---------- header height (hero tucks underneath) ---------- */
  var hdr = $("#hdr");
  function setHdr() {
    if (!hdr) return;
    document.documentElement.style.setProperty("--hdr-h", Math.round(hdr.offsetHeight) + "px");
  }
  setHdr();
  window.addEventListener("resize", setHdr);

  /* ---------- overlays ---------- */
  var scrim  = $("#scrim"),
      drawer = $("#drawer"),
      mmenu  = $("#mmenu"),
      sover  = $("#sover"),
      toast  = $("#toast"),
      lastFocus = null;

  function openOverlay(el, focusSel) {
    if (!el) return;
    closeAll(true);
    lastFocus = document.activeElement;
    el.classList.add("open");
    el.setAttribute("aria-hidden", "false");
    if (scrim) scrim.classList.add("open");
    document.body.style.overflow = "hidden";
    var f = focusSel ? $(focusSel, el) : $("button, a, input", el);
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function closeAll(silent) {
    [drawer, mmenu, sover].forEach(function (el) {
      if (!el) return;
      el.classList.remove("open");
      el.setAttribute("aria-hidden", "true");
    });
    if (scrim) scrim.classList.remove("open");
    document.body.style.overflow = "";
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add("open");
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove("open"); }, 2400);
  }
  /* keep Tab inside an open dialog */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeAll(); return; }
    if (e.key !== "Tab") return;
    var open = [drawer, mmenu, sover].filter(function (el) { return el && el.classList.contains("open"); })[0];
    if (!open) return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex="0"]', open)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- cart ---------- */
  function getCart() {
    return fetch(routes.cart, { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }
  function addItems(items) {
    return fetch(routes.cart_add, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || "Add to cart failed");
        return data;
      });
    });
  }
  function changeLine(key, quantity) {
    return fetch(routes.cart_change, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function renderShipBar(total) {
    var bar = $("#shipBar");
    if (!bar || !PB.freeShip) return;
    var left = PB.freeShip - total;
    var pct = Math.max(0, Math.min(100, (total / PB.freeShip) * 100));
    $("#shipFill").style.width = pct + "%";
    $("#shipMsg").innerHTML = left > 0
      ? esc(T.freeShipAway || "You're [amount] away from free shipping").replace("[amount]", "<b>" + money(left) + "</b>")
      : "<b>" + esc(T.freeShipDone || "Free shipping unlocked") + "</b>";
  }

  function renderDrawer(cart) {
    var badge = $("#cartCount");
    if (badge) {
      var prev = Number(badge.textContent);
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
      if (cart.item_count > prev) { badge.classList.remove("bump"); void badge.offsetWidth; badge.classList.add("bump"); }
    }
    var dc = $("#drawerCount"); if (dc) dc.textContent = cart.item_count;
    var sub = $("#drawerSubtotal");
    if (sub) sub.textContent = money(cart.total_price);
    renderShipBar(cart.total_price);

    var body = $("#cartBody");
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="empty"><span class="spec">' + esc(T.empty || "Your cart is empty") + '</span>' +
        '<p>' + esc(T.emptyBody || "") + '</p>' +
        '<a class="btn btn-primary btn-sm" href="' + esc(routes.all || "/collections/all") + '">' + esc(T.shopAll || "Shop all products") + '</a></div>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img class="line-img" src="' + esc(sizedImg(item.image, 160)) + '" alt="" width="72" height="72" loading="lazy">'
        : '<div class="line-img"></div>';
      var variant = (item.variant_title && item.variant_title !== "Default Title") ? item.variant_title : "";
      return '' +
        '<div class="line">' + '<a href="' + esc(item.url) + '">' + img + '</a>' +
          '<div class="line-info">' +
            '<h4><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h4>' +
            (variant ? '<span class="spec">' + esc(variant) + '</span>' : '') +
            '<div class="line-qty">' +
              '<button data-qty="-1" data-key="' + esc(item.key) + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-qty="1" data-key="' + esc(item.key) + '" aria-label="Increase quantity">+</button>' +
              '<button class="line-rm" data-remove="' + esc(item.key) + '">' + esc(T.remove || "Remove") + '</button>' +
              '<span class="line-price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join("");
  }

  function refresh(open) {
    return getCart().then(function (cart) {
      renderDrawer(cart);
      if (open) openOverlay(drawer, "#closeCart");
      return cart;
    });
  }

  /* ---------- add to cart, anywhere ---------- */
  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-add]");
    if (add) {
      e.preventDefault();
      var id = add.dataset.variant;
      if (!id) return;
      add.classList.add("is-loading");
      addItems([{ id: Number(id), quantity: 1 }])
        .then(function () { return refresh(true); })
        .catch(function (err) { showToast(err.message); })
        .then(function () { add.classList.remove("is-loading"); });
      return;
    }

    var q = e.target.closest("[data-qty]");
    if (q && q.dataset.key) {
      e.preventDefault();
      var line = q.closest(".line, .cart-line");
      var current = parseInt(line.querySelector(".line-qty span").textContent, 10);
      var next = current + parseInt(q.dataset.qty, 10);
      line.style.opacity = ".55";
      changeLine(q.dataset.key, Math.max(0, next)).then(function (cart) {
        renderDrawer(cart);
        if (document.body.classList.contains("template-cart")) location.reload();
      });
      return;
    }

    var rm = e.target.closest("[data-remove]");
    if (rm) {
      e.preventDefault();
      var l = rm.closest(".line, .cart-line"); if (l) l.style.opacity = ".55";
      changeLine(rm.dataset.remove, 0).then(function (cart) {
        renderDrawer(cart);
        if (document.body.classList.contains("template-cart")) location.reload();
      });
    }
  });

  /* ---------- product page ---------- */
  function initProduct() {
    var form = $("#productForm");
    if (!form || form._pb) return;
    form._pb = true;

    var variants = [];
    try { variants = JSON.parse(($("#pdpVariants") || {}).textContent || "[]"); } catch (err) {}
    var select = $("#variantSelect");
    var addBtn = $("#pdpAdd"), addLabel = $("#pdpAddLabel");
    var qtyEl = $("#pdpQty"), qtyInput = $("#qtyInput");
    var slides = $("#pdpSlides");
    var current = variants.filter(function (v) { return String(v.id) === select.value; })[0] || variants[0];

    function setQty(n) { qtyEl.textContent = n; if (qtyInput) qtyInput.value = n; }
    var up = $("#qtyUp"), down = $("#qtyDown");
    if (up)   up.addEventListener("click", function () { setQty(Math.min(20, parseInt(qtyEl.textContent, 10) + 1)); });
    if (down) down.addEventListener("click", function () { setQty(Math.max(1,  parseInt(qtyEl.textContent, 10) - 1)); });

    function goToMedia(mediaId, smooth) {
      if (!slides || !mediaId) return;
      var idx = $$(".pdp-slide", slides).findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (idx > -1) goToSlide(idx, smooth);
    }
    function goToSlide(i, smooth) {
      if (!slides) return;
      slides.scrollTo({ left: slides.clientWidth * i, behavior: smooth === false ? "auto" : "smooth" });
    }

    function applyVariant(v) {
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = T.unavailable || "Unavailable";
        return;
      }
      current = v;
      select.value = v.id;
      var price = money(v.price);
      $("#pdpPrice").textContent = price;
      var cmp = $("#pdpCompare");
      if (cmp) {
        cmp.hidden = !(v.compare_at_price > v.price);
        cmp.textContent = v.compare_at_price ? money(v.compare_at_price) : "";
      }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? (T.addToCart || "Add to cart") + " — " + price : (T.soldOut || "Sold out");
      var sp = $("#stickyPrice"); if (sp) sp.textContent = price;
      var sa = $("#stickyAdd"); if (sa) sa.disabled = !v.available;
      if (v.featured_media) goToMedia(v.featured_media.id);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    var radios = $$('.pdp-variants input[type="radio"]', form);
    radios.forEach(function (input) {
      input.addEventListener("change", function () {
        var chosen = [];
        $$(".pdp-opt", form).forEach(function (fs, i) {
          var c = $("input:checked", fs);
          chosen[i] = c ? c.value : null;
          var lbl = $('[data-opt-label="' + i + '"]', form);
          if (lbl && c) lbl.textContent = c.value;
        });
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        })[0];
        applyVariant(match);
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      addBtn.classList.add("is-loading");
      addItems([{ id: Number(select.value), quantity: parseInt(qtyEl.textContent, 10) || 1 }])
        .then(function () { return refresh(true); })
        .catch(function (err) { showToast(err.message); })
        .then(function () { addBtn.classList.remove("is-loading"); });
    });

    /* gallery: swipe on touch, thumbs + click-to-zoom on desktop */
    if (slides) {
      var thumbs = $$("[data-thumb]"), dots = $$(".pdp-dots span");
      thumbs.forEach(function (b) {
        b.addEventListener("click", function () { goToSlide(Number(b.dataset.thumb)); });
      });
      var onScroll = function () {
        var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        thumbs.forEach(function (t, k) { t.setAttribute("aria-pressed", k === i ? "true" : "false"); });
        dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
        $$(".pdp-slide.zoom", slides).forEach(function (s) { s.classList.remove("zoom"); });
      };
      slides.addEventListener("scroll", function () { cancelAnimationFrame(slides._r); slides._r = requestAnimationFrame(onScroll); }, { passive: true });
      if (window.matchMedia("(hover: hover)").matches) {
        $$(".pdp-slide", slides).forEach(function (s) {
          s.addEventListener("click", function () { s.classList.toggle("zoom"); });
          s.addEventListener("mousemove", function (e) {
            if (!s.classList.contains("zoom")) return;
            var r = s.getBoundingClientRect(), img = $("img", s);
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
          });
        });
      }
      if (current && current.featured_media) goToMedia(current.featured_media.id, false);
    }

    /* sticky buy bar */
    var sticky = $("#stickyBuy"), stickyAdd = $("#stickyAdd");
    if (sticky && "IntersectionObserver" in window) {
      var ftr = $(".ftr");
      var seen = { btn: true, ftr: false };
      var upd = function () {
        var show = !seen.btn && !seen.ftr;
        sticky.classList.toggle("show", show);
        sticky.setAttribute("aria-hidden", show ? "false" : "true");
        if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (en) { seen.btn = en[0].isIntersecting || en[0].boundingClientRect.top > 0; upd(); }).observe(addBtn);
      if (ftr) new IntersectionObserver(function (en) { seen.ftr = en[0].isIntersecting; upd(); }).observe(ftr);
      if (stickyAdd) stickyAdd.addEventListener("click", function () {
        if (radios.length) { addBtn.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true }));
      });
    }
  }

  /* ---------- recommendations ---------- */
  function initRecs() {
    $$("[data-recs]").forEach(function (el) {
      if (el._pb || !el.dataset.url) return;
      el._pb = true;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = $("[data-recs]", tmp);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; observeReveals(); }
        else el.hidden = true;
      }).catch(function () { el.hidden = true; });
    });
  }

  /* ---------- stack builder ---------- */
  function initStack() {
    var stack = $("#stackSlots");
    if (!stack || stack._pb) return;
    stack._pb = true;
    var picked = {};
    var slotKeys = $$(".opts", stack).map(function (o) { return o.dataset.slot; });
    var bubbles = $$("#stackPicks .stack-pick");
    var addBtn = $("#addStack");

    stack.addEventListener("click", function (e) {
      var b = e.target.closest("[data-pick]");
      if (!b) return;
      var slot = b.dataset.slotkey, id = b.dataset.pick;
      picked[slot] = picked[slot] === id ? null : id;
      $$(".opt", b.closest(".opts")).forEach(function (o) {
        o.setAttribute("aria-pressed", o.dataset.pick === picked[slot] ? "true" : "false");
      });
      var slotEl = b.closest(".slot"); if (slotEl) slotEl.classList.toggle("is-picked", !!picked[slot]);
      var total = 0, n = 0;
      slotKeys.forEach(function (k, i) {
        var bubble = bubbles[i];
        var chosenBtn = picked[k] ? $('[data-pick="' + picked[k] + '"][data-slotkey="' + k + '"]', stack) : null;
        if (chosenBtn) { total += Number(chosenBtn.dataset.price); n++; }
        if (bubble) {
          var img = chosenBtn && $("img", chosenBtn);
          bubble.innerHTML = img ? '<img src="' + esc(img.src) + '" alt="">' : "";
          bubble.classList.toggle("filled", !!chosenBtn);
        }
      });
      $("#stackTotal").textContent = money(total);
      addBtn.disabled = n === 0;
    });

    addBtn.addEventListener("click", function () {
      var items = Object.keys(picked)
        .filter(function (k) { return picked[k]; })
        .map(function (k) { return { id: Number(picked[k]), quantity: 1 }; });
      if (!items.length) return;
      addBtn.classList.add("is-loading");
      addItems(items)
        .then(function () {
          showToast(String(T.stackAdded || "[count] item stack added").replace("[count]", items.length));
          return refresh(true);
        })
        .catch(function (err) { showToast(err.message); })
        .then(function () { addBtn.classList.remove("is-loading"); });
    });
  }

  /* ---------- collection sort + filters ---------- */
  function initCollection() {
    var sortSel = $("#sortSel");
    var fForm = $("#filterForm");
    if (sortSel && !sortSel._pb) {
      sortSel._pb = true;
      sortSel.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sortSel.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    }
    if (fForm && !fForm._pb) {
      fForm._pb = true;
      var t;
      var submit = function () {
        document.body.classList.add("is-filtering");
        var params = new URLSearchParams(new FormData(fForm));
        Array.from(params.keys()).forEach(function (k) { if (params.get(k) === "") params.delete(k); });
        window.location.href = fForm.getAttribute("action") + "?" + params.toString();
      };
      fForm.addEventListener("change", function (e) {
        clearTimeout(t);
        t = setTimeout(submit, e.target.type === "number" ? 700 : 80);
      });
      fForm.addEventListener("submit", function (e) { e.preventDefault(); submit(); });
    }
  }

  /* ---------- nav: More + dropdowns ---------- */
  function initDrops() {
    var hoverable = window.matchMedia("(hover: hover)").matches;
    $$(".has-more, .has-drop").forEach(function (wrap) {
      if (wrap._pb) return;
      wrap._pb = true;
      var btn = $("button", wrap), menu = $(".more-menu, .drop", wrap), timer;
      var set = function (open) {
        menu.hidden = !open;
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      };
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var willOpen = menu.hidden;
        $$(".more-menu, .drop").forEach(function (m) { if (m !== menu) { m.hidden = true; var b = $("button", m.parentNode); if (b) b.setAttribute("aria-expanded", "false"); } });
        set(willOpen);
      });
      if (hoverable) {
        wrap.addEventListener("mouseenter", function () { clearTimeout(timer); set(true); });
        wrap.addEventListener("mouseleave", function () { timer = setTimeout(function () { set(false); }, 180); });
      }
      wrap.addEventListener("keydown", function (e) { if (e.key === "Escape") { set(false); btn.focus(); } });
      if ($('[aria-current="page"]', menu)) btn.setAttribute("aria-current", "page");
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest(".has-more, .has-drop")) return;
      $$(".more-menu, .drop").forEach(function (m) { m.hidden = true; });
      $$(".has-more > button, .has-drop > button").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    });
  }

  /* ---------- predictive search ---------- */
  function initSearch() {
    var btn = $("#searchBtn"), input = $("#soverInput"), out = $("#soverResults");
    if (!sover || !btn || !input) return;
    var initial = out.innerHTML, ctrl, t;
    btn.addEventListener("click", function (e) { e.preventDefault(); openOverlay(sover, "#soverInput"); });
    $("#closeSearch").addEventListener("click", function () { closeAll(); });

    function hl(text, q) {
      var safe = esc(text);
      if (!q) return safe;
      var re = new RegExp("(" + q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")", "ig");
      return safe.replace(re, "<mark>$1</mark>");
    }
    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var prods = r.products || [], cols = r.collections || [];
      if (!prods.length && !cols.length) {
        out.innerHTML = '<p class="lede">' + esc(T.noResults || "No results found") + ' &ldquo;' + esc(q) + '&rdquo;</p>';
        return;
      }
      out.innerHTML =
        '<div class="sres">' +
          '<div class="sres-cols">' + (cols.length ? '<h5>' + esc(T.collections || "Collections") + '</h5>' +
            cols.map(function (c) { return '<a href="' + esc(c.url) + '">' + hl(c.title, q) + '</a>'; }).join("") : "") + '</div>' +
          '<div><h5>' + esc(T.products || "Products") + '</h5><div class="sres-prods">' +
            prods.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(sizedImg(p.featured_image.url, 140)) + '" alt="" loading="lazy">' : "";
              return '<a class="sres-p" href="' + esc(p.url) + '">' + img + '<span>' + hl(p.title, q) + '<small>' + money(Math.round(parseFloat(p.price) * 100)) + '</small></span></a>';
            }).join("") +
          '</div>' +
          '<a class="btn btn-ghost btn-sm sres-all" href="' + esc(routes.search) + '?q=' + encodeURIComponent(q) + '&type=product">' + esc(T.viewAll || "View all results") + '</a>' +
          '</div>' +
        '</div>';
    }
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { out.innerHTML = initial; return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = "AbortController" in window ? new AbortController() : null;
        var url = (routes.predictive || "/search/suggest") + ".json?q=" + encodeURIComponent(q) +
          "&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last";
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) { render(d, q); })
          .catch(function () {});
      }, 160);
    });
  }

  /* ---------- announcement rotation ---------- */
  function initAnnounce() {
    $$("[data-rotate]").forEach(function (rot) {
      if (rot._pb) return;
      rot._pb = true;
      var msgs = $$(".announce-msg", rot);
      if (msgs.length < 2 || reduceMotion) return;
      var i = 0;
      setInterval(function () {
        if (document.hidden) return;
        msgs[i].classList.remove("is-on");
        i = (i + 1) % msgs.length;
        msgs[i].classList.add("is-on");
      }, 4200);
    });
  }

  /* ---------- headline split + count-up ---------- */
  function splitHeadlines() {
    $$(".h-hero[data-split]").forEach(function (h) {
      if (h._pb || reduceMotion) return;
      h._pb = true;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement("span"); w.className = "w";
              var inner = document.createElement("span"); inner.textContent = part;
              w.appendChild(inner); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1) { walk(n); }
        });
      };
      walk(h);
      $$(".w > span", h).forEach(function (s, i) { s.style.transitionDelay = (120 + i * 55) + "ms"; });
      requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add("in"); }); });
    });
  }
  function countUp(el) {
    if (el._pb) return;
    el._pb = true;
    var raw = el.dataset.count || el.textContent;
    var m = raw.match(/^(\D*)([\d,.]+)(.*)$/);
    if (!m || reduceMotion) return;
    var target = parseFloat(m[2].replace(/,/g, ""));
    if (!isFinite(target) || /^(19|20)\d\d$/.test(m[2])) return; /* years stay put */
    var decimals = (m[2].split(".")[1] || "").length, start = null, dur = 1400;
    var step = function (ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - p, 3);
      var v = (target * e).toFixed(decimals);
      if (m[2].indexOf(",") > -1) v = Number(v).toLocaleString("en-US");
      el.textContent = m[1] + v + m[3];
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }


  /* ---------- article: table of contents, reading progress, copy link ---------- */
  function initArticle() {
    var body = $("#artBody");
    if (!body || body._pb) return;
    body._pb = true;
    var toc = $("#artToc"), list = toc && $("ol", toc);
    var heads = $$("h2", body);
    if (toc && heads.length >= 2) {
      heads.forEach(function (h, i) {
        if (!h.id) h.id = (h.textContent || "section").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "s" + i;
        var li = document.createElement("li");
        li.innerHTML = '<a href="#' + h.id + '">' + esc(h.textContent) + "</a>";
        list.appendChild(li);
      });
      toc.hidden = false;
      var links = $$("a", list);
      if ("IntersectionObserver" in window) {
        var obs = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (a) { a.classList.toggle("on", a.getAttribute("href") === "#" + e.target.id); });
          });
        }, { rootMargin: "0px 0px -70% 0px" });
        heads.forEach(function (h) { obs.observe(h); });
      }
    }
    var bar = $("#readBar");
    if (bar) {
      var upd = function () {
        var r = body.getBoundingClientRect(), total = body.offsetHeight - window.innerHeight * 0.6;
        var p = Math.max(0, Math.min(1, -r.top / Math.max(1, total)));
        bar.style.width = (p * 100) + "%";
      };
      window.addEventListener("scroll", function () { requestAnimationFrame(upd); }, { passive: true });
      upd();
    }
    $$("[data-copy]").forEach(function (b) {
      b.addEventListener("click", function () {
        var done = function () { showToast(T.linkCopied || "Link copied"); };
        if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.copy).then(done, done); else done();
      });
    });
  }

  /* ---------- reveal on scroll ---------- */
  var io = null;
  function observeReveals() {
    var targets = $$(".rv:not(.in)");
    var counters = $$("[data-count]");
    if (!("IntersectionObserver" in window) || reduceMotion) {
      targets.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    if (!io) io = new IntersectionObserver(function (entries) {
      var batch = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.hasAttribute("data-count")) { countUp(el); io.unobserve(el); return; }
        el.style.transitionDelay = (batch++ % 4) * 70 + "ms";
        el.classList.add("in");
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px" });
    targets.forEach(function (el) { io.observe(el); });
    counters.forEach(function (el) { if (!el._pb) io.observe(el); });
  }

  /* ---------- header scroll states ---------- */
  if (hdr) {
    var lastY = window.scrollY, ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        hdr.classList.toggle("stuck", y > 20);
        var anyOpen = $$(".more-menu:not([hidden]), .drop:not([hidden])").length > 0;
        hdr.classList.toggle("is-hidden", y > 480 && y > lastY + 4 && !anyOpen);
        if (y < lastY - 4 || y < 480) hdr.classList.remove("is-hidden");
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- wire-up ---------- */
  var cartBtn = $("#cartBtn");
  if (cartBtn) cartBtn.addEventListener("click", function () { refresh(true); });
  var burger = $("#burger");
  if (burger) burger.addEventListener("click", function () { openOverlay(mmenu, "#closeMenu"); });
  [$("#closeCart"), $("#closeMenu")].forEach(function (b) { if (b) b.addEventListener("click", function () { closeAll(); }); });
  if (scrim) scrim.addEventListener("click", function () { closeAll(); });
  $$("#mmenu a").forEach(function (a) { a.addEventListener("click", function () { closeAll(true); }); });

  function initAll() {
    setHdr();
    splitHeadlines();
    observeReveals();
    initProduct();
    initRecs();
    initStack();
    initCollection();
    initDrops();
    initAnnounce();
    initArticle();
  }
  initAll();
  initSearch();
  refresh(false);

  /* keep everything working after a customizer section reload */
  document.addEventListener("shopify:section:load", function () { initAll(); refresh(false); });
})();
